<template>
<el-dialog title="Import Template" :visible.sync="modal" top="8vh" width="550px">
    <el-link style="margin-bottom:20px;" type="primary" @click="downloadTemplate">Download Template</el-link>
    <el-form>
        <el-form-item size="medium">
            <el-upload action="" :auto-upload="false" :show-file-list="false" :file-list="fileList" :multiple="false" :limit="2" :on-change="onChange">
                <el-input :value="filename" readonly style="width: 510px;">
                    <el-button slot="prepend" type="primary">Choose File</el-button>
                </el-input>
            </el-upload>
        </el-form-item>

        <el-form-item size="medium">
            <el-button :loading="loading" :disabled="loading" type="primary" @click="handleUpload">Upload</el-button>
            <el-button style="float:right;" type="danger" plain @click="handleClear">Clear</el-button>
        </el-form-item>
    </el-form>
</el-dialog>
</template>

<script>
export default {
    data: () => ({
        modal: false,
        fileList: [],
        filename: '',
        qbTemplate: process.env.VUE_APP_Extensiv_TEMPLATE,
        loading: false
    }),
    methods: {
        downloadTemplate() {
            // Local public file; replace with bucket URL when available.
            this.$downloadFile('Extensiv_PO_upload_template v1.xlsx', '/Extensiv_PO_upload_template%20v1.xlsx');
        },
        onChange(files, fileList) {
            this.fileList = [];
            this.fileList.push(files.raw);
            this.filename = files.name
        },
        handleClear() {
            this.fileList = []
            this.filename = ''
        },
        handleUpload() {
            if (this.fileList.length < 1 && !this.filename) {
                this.$message({
                    type: 'error',
                    message: 'Please select file.'
                })
            } else {
                this.handleSubmit();
            }
        },
        async handleSubmit() {
            this.loading = true;
            try {
                let formData = new FormData();
                formData.append('myFile', this.fileList[0]);
                formData.append('user_id', JSON.parse(localStorage.getItem('user')).employee_id);
                formData.append('user_name', JSON.parse(localStorage.getItem('user')).user_name);
                formData.append('user_email', JSON.parse(localStorage.getItem('user')).email);
                // $http baseURL already includes /api; keep relative path
                let response = await this.$http.post('/extensiv/upload', formData, {
                    headers: {
                        'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    }
                });
                this.loading = false
                this.modal = false
                this.$emit('onSuccess', {
                    type: 'success',
                    message: response.data.msg
                });
            } catch (error) {
                this.loading = false;
                this.modal = false
                this.$emit('onError', {
                    type: 'error',
                    message: error.data.msg
                });
            }
        },
        viewImportForm() {
            this.modal = true
        }
    }
}
</script>
